// extracted by mini-css-extract-plugin
module.exports = {"root":"WorkerWithPosition_root__1E40Z","speciality":"WorkerWithPosition_speciality__3ZphD"};